'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _Root = require('containers/Root');

var _Root2 = _interopRequireDefault(_Root);

var _Errors = require('containers/Errors');

var _Errors2 = _interopRequireDefault(_Errors);

var _Home = require('containers/Home');

var _Home2 = _interopRequireDefault(_Home);

var _Creative = require('containers/Creative');

var _Creative2 = _interopRequireDefault(_Creative);

var _Technical = require('containers/Technical');

var _Technical2 = _interopRequireDefault(_Technical);

var _Work = require('containers/Work');

var _Work2 = _interopRequireDefault(_Work);

var _Project = require('containers/Project');

var _Project2 = _interopRequireDefault(_Project);

var _Contact = require('containers/Contact');

var _Contact2 = _interopRequireDefault(_Contact);

var _Publishing = require('containers/Publishing');

var _Publishing2 = _interopRequireDefault(_Publishing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_reactGa2.default.initialize('UA-109451619-1', {
  debug: true
});

exports.default = _react2.default.createElement(
  _reactRouter.Route,
  { path: '/', component: _Root2.default },
  _react2.default.createElement(_reactRouter.IndexRoute, { component: _Home2.default }),
  _react2.default.createElement(_reactRouter.Route, { path: 'showreel', component: _Home2.default }),
  _react2.default.createElement(_reactRouter.Route, { path: 'creative', component: _Creative2.default }),
  _react2.default.createElement(_reactRouter.Route, { path: 'technical', component: _Technical2.default }),
  _react2.default.createElement(_reactRouter.Route, { path: 'work', component: _Work2.default }),
  _react2.default.createElement(_reactRouter.Route, { path: 'work/:slug', component: _Project2.default }),
  _react2.default.createElement(_reactRouter.Route, { path: 'contact', component: _Contact2.default }),
  _react2.default.createElement(_reactRouter.Route, { path: 'publishing', component: _Publishing2.default }),
  _react2.default.createElement(_reactRouter.Route, { path: '*', component: _Errors2.default })
);


//////////////////
// WEBPACK FOOTER
// ./src/routes/index.js
// module id = 358
// module chunks = 1